
import { defineComponent, onBeforeMount, ref } from 'vue';
import moment from 'moment';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { invokeAssignProxyToLearners, invokegetSkillProf, invokeLearnerForProxyReviewer } from '@/utils/admin/assign_proxy_service';
import { invokegetAllProgram } from '@/utils/admin/task_management_service';
import { invokegetAllProxies } from '@/utils/admin/manage_proxy_service';
import SearchBar from '@/components/global/SearchBar.vue';

// eslint-disable-next-line
// import router from '@/router';
// import { XIcon } from 'vue-feather-icons';

export default defineComponent({
  name: 'AssignProxy',
  components: { SearchBar },
  setup() {
    const learnerData = ref();
    const skills = ref();
    const proficiency = ref();
    const renderReady = ref();
    const selectedSkill = ref();
    const selectedProficiency = ref();
    const isVisible = ref(false);
    const proxyButtonVisible = ref(false);
    const proxyList = ref();
    const selectedTaskId = ref([]);
    const selectedProxyOhr = ref();
    const proxyAssignedBtn = ref(false);
    const userRole = ref();
    const programDetails = ref();
    const showScreen = ref(true);
    const showSkillProf = ref(false);
    const selectedProgram = ref();
    const programErrorMessage = ref();
    const skillErrorMessage = ref();
    const proficiencyError = ref();
    const proxyDetailsArray = ref();
    const filteredproxyDetails = ref();

    const checkOne = () => {
      selectedProxyOhr.value = [];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const setProxyBtn = (event: any) => {
      const cb = event.target.checked;
      // console.log('length', cb.length);
      if (cb === true) {
        console.log('selected Task id', selectedTaskId.value);
        proxyButtonVisible.value = true;
        // console.log(cb);
      } else if (selectedTaskId.value.length === 0) {
        proxyButtonVisible.value = false;
        isVisible.value = false;
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const FilterData: any = {};
    const getProgram = async () => {
      renderReady.value = false;
      programDetails.value = await invokegetAllProgram('/cache?cache=program');
      // console.log(programDetails.value);
      renderReady.value = true;
    };
    const getSkillandProf = async () => {
      renderReady.value = false;
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const dataRes: any = await invokegetSkillProf('/getAllSkillProf?skill_type=genome');
      skills.value = dataRes.skill;
      proficiency.value = dataRes.proficiency;
      renderReady.value = true;
    };
    const getLearnerForProxy = async () => {
      try {
        if (!selectedProgram.value) {
          programErrorMessage.value = 'Please Select Program';
          setTimeout(() => {
            programErrorMessage.value = null;
          }, 6000);
          return;
        }
        if (selectedProgram.value === 'infinity') {
          if (!selectedSkill.value) {
            skillErrorMessage.value = 'Please Select Skill';
            setTimeout(() => {
              skillErrorMessage.value = null;
            }, 6000);
            return;
          }
          if (!selectedProficiency.value) {
            proficiencyError.value = 'Please Select Proficiency';
            setTimeout(() => {
              proficiencyError.value = null;
            }, 6000);
            return;
          }
        }

        // if (FilterData.skill && FilterData.proficiency) {
        // console.log(FilterData);
        renderReady.value = false;
        await checkOne();
        selectedTaskId.value = [];
        proxyButtonVisible.value = false;
        // selectedTaskId.value.length == 0;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const resLearnerList: any = await invokeLearnerForProxyReviewer('/learnerTaskToProxyAssign', FilterData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const dataRes: any = resLearnerList.data;
        learnerData.value = dataRes.learnerToProxyAssign;
        // const sortedArray = dataRes.sort((a: any, b: any) => moment(b.proxy_requested_date).utc().unix() - moment(a.submission_date).utc().unix());
        if (learnerData.value) {
          for (let index = 0; index < learnerData.value.length; index += 1) {
            const res = learnerData.value[index];
            const today = moment().utc().format('YYYY-MM-DD');
            if (res.proxy_requested_date) {
              const requestedDateFormatted = moment(res.proxy_requested_date).utc().format('YYYY-MM-DD');
              res.ageing = moment(today).diff(moment(requestedDateFormatted), 'days');
              res.proxy_requested_date = moment(res.proxy_requested_date).format('DD-MM-YYYY');
            }
            if (res.submission_date) {
              res.submission_date = moment(res.submission_date).format('DD-MM-YYYY');
            }
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          learnerData.value = learnerData.value.sort((a: any, b: any) => b.ageing - a.ageing);
        }

        isVisible.value = false;
        console.log('Learner Data', learnerData.value);
        renderReady.value = true;
        // }
      } catch (error) {
        console.log(error);
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProgram = async (e: any) => {
      selectedProgram.value = e.target.value;
      Object.assign(FilterData, { program_id: selectedProgram.value });
      if (selectedProgram.value !== 'Select Program') {
        if (selectedProgram.value === 'infinity') {
          showSkillProf.value = true;
        } else {
          selectedSkill.value = '';
          showSkillProf.value = false;
        }
      }
      // localStorage.setItem('program', selectedProgram.value);
      // localStorage.removeItem('inputValue');
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedSkill = async (e: any) => {
      // console.log(e.target.removeAttr('selected'));
      selectedSkill.value = e.target.value;
      Object.assign(FilterData, { skill: selectedSkill.value });

      // await getLearnerForProxy();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedProficiency = async (e: any) => {
      selectedProficiency.value = e.target.value;
      Object.assign(FilterData, { proficiency: selectedProficiency.value });
      // isVisible.value = false;
      // await getLearnerForProxy();
    };
    const showProxy = async () => {
      isVisible.value = true;
      renderReady.value = false;
      let url = `/v2/admin/proxy/program/${selectedProgram.value}`;
      if (!selectedProgram.value) {
        programErrorMessage.value = 'Please Select Program';
        setTimeout(() => {
          programErrorMessage.value = null;
        }, 6000);
        return;
      }
      if (selectedProgram.value === 'infinity') {
        url = `/v2/admin/proxy/program/infinity/skill/${selectedSkill.value}`;
        if (!selectedSkill.value) {
          skillErrorMessage.value = 'Please Select Skill';
          setTimeout(() => {
            skillErrorMessage.value = null;
          }, 6000);
          return;
        }
      }
      const res = await invokegetAllProxies(url);
      proxyList.value = res.all_proxies;
      proxyDetailsArray.value = proxyList.value.map((proxy) => proxy.proxy_name);
      filteredproxyDetails.value = proxyList.value;
      console.log('Proxy Data', proxyList.value);
      // proxyList.value = await invokeGetProxyList('/getAllProxyBySkill', selectedSkill.value);
      renderReady.value = true;
      console.log('Proxy List', proxyList.value);
    };
    const getFilteredList = (value) => {
      // filteredProgramDetails.value = value;
      // console.log('ProgramDetails.value in final', ProgramDetails.value);
      filteredproxyDetails.value = proxyList.value.filter((proxy) => value.includes(proxy.proxy_name));
      console.log('filteredproxyDetails', filteredproxyDetails.value);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showAssignProxyBtn = async (event: any) => {
      const proxyOhr = event.target.checked;
      if (proxyOhr === true) {
        proxyAssignedBtn.value = true;
      } else {
        proxyAssignedBtn.value = false;
      }
    };
    const assignLearnerToProxy = async () => {
      try {
        renderReady.value = false;
        const data = {
          proxy_key: selectedProxyOhr.value[0],
          learners: selectedTaskId.value,
          linked_program_name: selectedProgram.value,
          skill: selectedSkill.value,
          proficiency: selectedProficiency.value,
        };
        console.log('Selected Data', data);
        const assignProxyRes = await invokeAssignProxyToLearners('/proxyreview', data);
        isVisible.value = false;
        await getLearnerForProxy();
        // router.push({ path: 'assignProxy' });
        // router.go(0);
        renderReady.value = true;
        console.log('data ohr', assignProxyRes);
      } catch (error) {
        console.log('data ohr', error);
      }
    };
    onBeforeMount(async () => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const role: any = await invokeGetUserRole('/getUserRole');
      userRole.value = role.user_roles;
      if (userRole.value.length > 0) {
        console.log('inside length');
        if (userRole.value.includes('System Admin') || userRole.value.includes('Proxy Admin') || userRole.value.includes('Community Manager')) {
          showScreen.value = true;
          await getSkillandProf();
          await getProgram();
        } else {
          showScreen.value = false;
        }
      }
    });
    return {
      learnerData,
      skills,
      proficiency,
      renderReady,
      getSelectedSkill,
      getSelectedProficiency,
      isVisible,
      showProxy,
      getSkillandProf,
      getLearnerForProxy,
      selectedTaskId,
      proxyButtonVisible,
      setProxyBtn,
      proxyList,
      selectedProxyOhr,
      checkOne,
      showAssignProxyBtn,
      proxyAssignedBtn,
      assignLearnerToProxy,
      showScreen,
      programDetails,
      showSkillProf,
      getSelectedProgram,
      programErrorMessage,
      skillErrorMessage,
      proficiencyError,
      proxyDetailsArray,
      getFilteredList,
      filteredproxyDetails,
    };
  },
});
